/**
 * Map Axios errors to structured, user-friendly codes and messages for web.
 * Mirrors the mobile classifier so UX stays consistent across platforms.
 *
 * If the server returns a structured error with a `code` field (e.g., refresh
 * token failures), that code is preserved for client-side handling.
 */
export function classifyAxiosError(err, fallback) {
    const status = err.response?.status;
    const data = err.response?.data;
    // Extract server-provided code and message from structured responses
    const serverCode = data && typeof data === 'object' && 'code' in data
        ? String(data.code ?? '')
        : undefined;
    const serverMessage = typeof data === 'string'
        ? data
        : data && typeof data === 'object' && 'message' in data
            ? String(data.message ?? '')
            : undefined;
    // Prefer server-provided code (e.g., REFRESH_SESSION_EXPIRED) if present
    let code = serverCode?.trim() || 'unknown-error';
    if (!serverCode) {
        if (status === 400)
            code = 'invalid-request';
        else if (status === 401 || status === 403)
            code = 'otp-invalid';
        else if (status === 404)
            code = 'invalid-request';
        else if (status === 409)
            code = 'already-exists';
        else if (status === 410 || status === 422)
            code = 'otp-expired';
        else if (status === 429)
            code = 'otp-rate-limited';
        else if (typeof status === 'number' && status >= 500)
            code = 'server-error';
        else if (!err.response)
            code = 'network-error';
    }
    const message = serverMessage?.trim() || (status ? `${fallback} (${status})` : fallback);
    return { code, message };
}
//# sourceMappingURL=error-classify.js.map